import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Trip } from "@mapmycustomers/shared/types/entity";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import MileageTrackingCardData from "@app/scene/dashboard/store/cards/mileageTracking/MileageTrackingCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import MileageTrackingCardConfiguration from "@app/types/dashboard/cards/mileageTracking/MileageTrackingCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

export const fetchMileageTrackingCardData = createAction(
  "@dashboard/fetchMileageTrackingCardData"
)<{
  callback: (data: MileageTrackingCardData) => void;
  configuration: MileageTrackingCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showMileageTrackingDrillDown = createAsyncAction(
  "@dashboard/showMileageTrackingCardDrillDownModal/request",
  "@dashboard/showMileageTrackingCardDrillDownModal/success",
  "@dashboard/showMileageTrackingCardDrillDownModal/failure"
)<
  {
    configuration: MileageTrackingCardConfiguration;
    customDateRange?: DateRange;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideMileageTrackingDrillDown = createAction(
  "@dashboard/hideMileageTrackingCardDrillDownModal"
)<void>();

export const fetchMileageTrackingCardDrillDownData = createAsyncAction(
  "@dashboard/fetchMileageTrackingCardDrillDownData/request",
  "@dashboard/fetchMileageTrackingCardDrillDownData/success",
  "@dashboard/fetchMileageTrackingCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<Trip>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyMileageTrackingDrillDownListViewSettings = createAction(
  "@dashboard/applyMileageTrackingDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportMileageTrackingCardDrillDownData = createAction(
  "@dashboard/exportMileageTrackingCardData"
)<{
  configuration: MileageTrackingCardConfiguration;
  scope: Scope;
}>();

export const updateTrip = createAsyncAction(
  "@dashboard/updateTrip/request",
  "@dashboard/updateTrip/success",
  "@dashboard/updateTrip/failure"
)<{ entity: Trip; onFailure?: () => void; onSuccess?: (trip: Trip) => void }, Trip, unknown>();

export type MileageTrackingCardActions = ActionType<
  | typeof applyMileageTrackingDrillDownListViewSettings
  | typeof exportMileageTrackingCardDrillDownData
  | typeof fetchMileageTrackingCardData
  | typeof fetchMileageTrackingCardDrillDownData
  | typeof hideMileageTrackingDrillDown
  | typeof showMileageTrackingDrillDown
  | typeof updateTrip
>;
